/* Rigid illustration components. No mesh warping, displacement, or image-wide movement. */
window.PersonalEngravingMotion = class {
 constructor(scene) {
  this.scene=scene;this.time=0;this.running=false;this.loaded=false;this.animated=false;this.serial=0;
  this.canvas=document.createElement('canvas');this.canvas.className='pr-scene-canvas';this.canvas.setAttribute('aria-hidden','true');
  scene.querySelector('.pr-scene-images').append(this.canvas);
  this.ctx=this.canvas.getContext('2d');if(!this.ctx)throw Error('Static fallback');
  this.resize=new ResizeObserver(()=>this.draw());this.resize.observe(this.canvas);
  this.bases=new Map();
 }
 async setImage(image,key){
  const serial=++this.serial;this.stop();this.loaded=false;this.scene.dataset.canvasReady='false';
  let base=image;
  if(key==='career'&&image.dataset.mechanicalBase){
   const url=image.dataset.mechanicalBase;
   if(!this.bases.has(url)){
    const part=new Image();part.crossOrigin='anonymous';part.src=url;
    this.bases.set(url,part.decode().then(()=>part));
   }
   base=await this.bases.get(url);
  }
  if(serial!==this.serial)return;
  this.image=base;this.key=key;this.time=0;
  this.animated=['career','decision','timing'].includes(key);this.loaded=true;this.draw();
 }
 draw(){
  if(!this.loaded)return;
  const rect=this.canvas.getBoundingClientRect(),w=Math.max(1,Math.min(1200,Math.round(rect.width*Math.min(devicePixelRatio||1,1.5)))),h=Math.round(w*2/3);
  if(this.canvas.width!==w||this.canvas.height!==h){this.canvas.width=w;this.canvas.height=h;}
  const c=this.ctx;c.setTransform(1,0,0,1,0,0);c.clearRect(0,0,w,h);c.scale(w/1536,h/1024);
  const image=()=>c.drawImage(this.image,0,0,1536,1024);
  if(this.key==='decision'){
   // Fixed column/base. Beam halves rotate as rigid pieces about the central bearing.
   c.save();c.beginPath();c.rect(699,0,138,740);c.rect(0,694,1536,330);c.clip();image();c.restore();
   const angle=Math.sin(this.time*Math.PI/7)*.018;
   c.save();c.translate(768,195);c.rotate(angle);c.translate(-768,-195);
   c.beginPath();c.rect(0,132,700,108);c.rect(837,132,699,108);c.clip();image();c.restore();
   // The hanging assemblies translate with the beam ends, remaining vertical and level.
   for(const side of [-1,1]){
    const dx=side*371*(Math.cos(angle)-1),dy=side*371*Math.sin(angle);
    c.save();c.translate(dx,dy);c.beginPath();c.rect(side<0?0:837,240,side<0?699:699,454);c.clip();image();c.restore();
   }
   // The bearing cover stays still, concealing the mechanical joint.
   c.save();c.beginPath();c.ellipse(768,195,48,58,0,0,Math.PI*2);c.clip();image();c.restore();
  }else{
   image();
   if(this.key==='career'){
    // Perspective-projected rigid magnetic needle. The printed rose and case never move.
    c.save();c.translate(717,568);c.scale(1,.65);c.rotate(.025*Math.sin(this.time*Math.PI/5)+.25);
    c.shadowColor='#0009';c.shadowBlur=4;c.shadowOffsetY=5;
    c.beginPath();c.moveTo(0,-163);c.lineTo(19,0);c.lineTo(0,145);c.lineTo(-19,0);c.closePath();c.fillStyle='#ac823b';c.fill();
    c.shadowColor='transparent';c.beginPath();c.moveTo(0,-163);c.lineTo(19,0);c.lineTo(0,145);c.closePath();c.fillStyle='#eed38a';c.fill();
    c.beginPath();c.moveTo(0,-148);c.lineTo(0,130);c.strokeStyle='#74501e';c.lineWidth=2;c.stroke();c.restore();
    c.save();c.translate(717,568);c.fillStyle='#735021';c.beginPath();c.ellipse(0,0,21,15,0,0,Math.PI*2);c.fill();c.strokeStyle='#eed38a';c.lineWidth=3;c.stroke();c.restore();
   }
   if(this.key==='timing'){
    // Only discrete grains fall under gravity; the glass, frame and sand banks are fixed.
    c.save();c.beginPath();c.moveTo(750,489);c.lineTo(774,489);c.lineTo(810,695);c.lineTo(714,695);c.closePath();c.clip();
    for(let i=0;i<42;i++){
     const phase=(this.time*.62+i*.61803398875)%1;
     const y=489+202*phase*phase;
     const x=759+Math.sin(i*12.9898)*(.8+phase*5);
     c.fillStyle=i%3===0?'#f2d998':'#c8a55c';c.globalAlpha=.55+phase*.25;c.fillRect(x,y,1.4,i%2?2.2:1.4);
    }
    c.restore();
   }
  }
 }
 start(){
  if(this.running||!this.animated||!this.loaded)return;this.running=true;this.last=0;
  const tick=now=>{if(!this.running)return;if(!this.last)this.last=now;if(now-this.last>=40){this.time+=Math.min((now-this.last)/1000,.1);this.last=now;this.draw();}this.frame=requestAnimationFrame(tick);};
  this.frame=requestAnimationFrame(tick);
 }
 stop(){this.running=false;cancelAnimationFrame(this.frame);this.last=0;}
 destroy(){this.serial++;this.stop();this.resize.disconnect();this.canvas.remove();}
};
